import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, CSP_NONCE, ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpService, StatusService } from 'ui-components/common';
import { DomHandler } from 'ui-components/dom';
import { FileDownloadService } from 'ui-components/filedownload';
import { LanguageService } from 'ui-components/messages';
import { ValidatorService } from 'ui-components/validator';
import { routes } from './app.routes';
import { AxthGuard } from './guards/axth.guard';
import { AxthenticationService, ShareService } from './services';
import { NavigationService } from './services/navigation.service';
import { TxnService } from './services/txn.service';
import { UploadService } from './services/upload.service';
import { ConsoleService } from './shared/core/services/console.service';
import { GlobalErrorHandler } from './shared/core/services/global.error.handle';
import { AppConsoleConfig, LogService } from './shared/core/services/log.service';

export function provideCspNonce() {
  let nonce = '';
  let nonceSource = 'unknown';

  try {
    // 取得當前頁面的 nonce
    if (!nonce) {
      // 嘗試從共用的 style 元素取得 nonce
      const sharedStyleElement = document.getElementById('gib-dynamic-styles');
      if (sharedStyleElement) {
        nonce = sharedStyleElement.getAttribute('nonce') || '';
        if (nonce && nonce.trim() !== '' && !nonce.includes('<!--')) {
          nonceSource = 'current-shared-style';
          // console.log('[CSP_NONCE] Found nonce from current shared style:', nonce + '...');
        }
      }

      // 如果共用 style 元素沒有 nonce，嘗試從 app 元素取得
      if (!nonce) {
        const nonceElement = document.querySelector('GIB-App, gib-app, app-root');
        if (nonceElement) {
          nonce = nonceElement.getAttribute('nonce') ||
            nonceElement.getAttribute('data-nonce') || '';
          if (nonce && nonce.trim() !== '' && !nonce.includes('<!--')) {
            nonceSource = 'current-app-element';
          }
        }
      }

      // 最後嘗試從任何有 nonce 的元素取得
      if (!nonce) {
        const anyNonceElement = document.querySelector('[nonce], script[nonce], style[nonce]');
        if (anyNonceElement) {
          nonce = anyNonceElement.getAttribute('nonce') || '';
          if (nonce && nonce.trim() !== '' && !nonce.includes('<!--')) {
            nonceSource = 'any-element';
            // console.log('[CSP_NONCE] Found nonce from any element:', nonce + '...');
          }
        }
      }
    }

    // 最終的調試信息
    // console.log('[CSP_NONCE] Final result:', {
    //   nonce: nonce ? nonce + '...' : 'NOT_FOUND',
    //   nonceSource: nonceSource,
    //   isInFrame: window !== window.top,
    //   frameDepth: window !== window.top ? 'child' : 'top',
    //   documentTitle: document.title,
    //   timestamp: new Date().toISOString()
    // });

  } catch (error) {
    console.error('[CSP_NONCE] Error during nonce detection:', error);
    nonceSource = 'error';
  }

  return nonce || '';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: CSP_NONCE, useFactory: provideCspNonce },
    { provide: LocationStrategy, useClass: HashLocationStrategy },

    // 核心服務 - 只保留一個註冊
    LogService,
    HttpService,
    DomHandler,
    StatusService,
    ShareService,
    LanguageService,
    AxthenticationService,
    ValidatorService,

    // 其他服務
    ConsoleService,
    AppConsoleConfig,
    AxthGuard,
    TxnService,
    UploadService,
    NavigationService,
    FileDownloadService,

    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};

